var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPetWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 9.03614C4 9.86012 4.61111 10.5604 5.39683 10.8178V18.9157H4V20H20V18.9157H18.6032V10.8165C19.4216 10.5789 19.9809 9.88904 20 9.03614V8.55422H4V9.03614ZM8.01841 8.99675C8.01841 9.38693 8.4473 10.8925 10.0328 10.8925C11.4099 10.8925 12.0139 9.7109 12.0139 8.99675C12.0139 9.66253 12.4844 10.8911 14.0116 10.8911C15.3915 10.8911 16.0029 9.62614 16.0029 8.99675C16.0029 9.86572 16.6204 10.5881 17.4603 10.8133V18.9157H6.53968V10.8189C7.3906 10.6004 8.01841 9.87319 8.01841 8.99675ZM18.0211 6.20482H18.0317V5H6.03175V6.20482L4 8.13253H20L18.0211 6.20482Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8603 16.1161C14.6636 15.057 13.5336 14.196 12.3403 14.196C11.0436 14.196 9.90359 15.1411 9.79359 16.3051C9.75025 16.7551 9.91025 17.1811 10.2403 17.5021C10.5669 17.8231 11.0269 18.0001 11.5269 18.0001H13.0869C13.6503 18.0001 14.1436 17.8021 14.4803 17.4451C14.8169 17.0881 14.9503 16.6141 14.8603 16.1161Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9264 13.758C12.4658 13.758 12.903 13.3645 12.903 12.879C12.903 12.3935 12.4658 12 11.9264 12C11.387 12 10.9497 12.3935 10.9497 12.879C10.9497 13.3645 11.387 13.758 11.9264 13.758Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1468 14.1085C14.596 14.1085 14.9602 13.7808 14.9602 13.3765C14.9602 12.9723 14.596 12.6445 14.1468 12.6445C13.6976 12.6445 13.3335 12.9723 13.3335 13.3765C13.3335 13.7808 13.6976 14.1085 14.1468 14.1085Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3497 15.2794C15.7087 15.2794 15.9997 15.0175 15.9997 14.6944C15.9997 14.3713 15.7087 14.1094 15.3497 14.1094C14.9907 14.1094 14.6997 14.3713 14.6997 14.6944C14.6997 15.0175 14.9907 15.2794 15.3497 15.2794Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81333 14.6945C10.2625 14.6945 10.6267 14.3668 10.6267 13.9625C10.6267 13.5582 10.2625 13.2305 9.81333 13.2305C9.36414 13.2305 9 13.5582 9 13.9625C9 14.3668 9.36414 14.6945 9.81333 14.6945Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetWhite);
export default __webpack_public_path__ + "static/media/pet-white.e5c4b61c9ae54cdfbe0fbd3addb55589.svg";
export { ForwardRef as ReactComponent };